import { Layout } from 'antd'
import { FC, useEffect } from 'react'
import { useAppSelector } from '../../app/hook'
import { IMGs } from '../../assets/img'
import { LeaderBoardLayout } from '../../components'
import { Header, SeasonRunningStatus } from './components'
import { useTranslation } from 'react-i18next'

export const SeasonRunning: FC<unknown> = () => {
    const { t } = useTranslation()
    const { season } = useAppSelector((state) => state.leaderBoard)
    const setSeasonStatus = (seasonStatus: string, countDownTime: number) => {
        console.log(seasonStatus, countDownTime, 'setSeasonStatus')
    }

    useEffect(() => {
        window.setSeasonStatus = setSeasonStatus
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    return (
        <LeaderBoardLayout isSeasonHeaderHidden>
            <Layout
                style={{
                    background: 'transparent',
                    backgroundImage: `url(${IMGs.END_SEASON})`,
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    minHeight: '100vh',
                }}
            >
                <Header
                    title={t('txt_trading_simulator')}
                    subTitle={season?.title}
                />

                <SeasonRunningStatus
                    title={t('txt_calc_rewards')}
                    description={t('txt_calc_rewards_des')}
                />
            </Layout>
        </LeaderBoardLayout>
    )
}
